import { Box, Grid, makeStyles } from '@material-ui/core';

const SGSMessageBox = ({ Message }) => {
    const classes = useStyles();
    return (
        <Box className={`${classes.row} ${classes.middleRow}`}>
            <Grid container justifyContent="center" alignItems="center">
                <Grid item md={2} className={'p-5'}></Grid>
                <Grid item md={8} className={'pt-5'}>
                    <Box className={classes.box}>{Message({ classes })}</Box>
                </Grid>
                <Grid item md={2} className={'p-5'}></Grid>
            </Grid>
        </Box>
    );
};

export default SGSMessageBox;

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
    },
    row: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: '1px solid #ccc',
    },
    middleRow: {
        flex: 2,
    },
    titre: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#2574A9',
        fontFamily: 'Open Sans',
        fontSize: 22,
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: 'normal',
        textAlign: 'center',
        paddingRight: '20px',
        paddingLeft: '20px',
    },

    sousTitre: {
        color: '#2574A9',
        fontFamily: 'Open Sans',
        fontSize: '22px',
        fontStyle: 'normal',
        fontWeight: 600,
        marginTop: '10px',
        lineHeight: 'normal',
    },

    txt: {
        color: '#4F7793',
        fontFamily: 'Open Sans',
        fontSize: '18px',
        fontStyle: 'normal',
        lineHeight: '26px',
        fontWeight: 400,
        marginTop: '30px',
    },
    pill: {
        borderRadius: '50%',
        background: '#46BE81',
        color: '#fff',
        width: '30px',
        height: '30px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        lineHeight: 'normal',
    },
    pillText: {
        color: '#4F7793',
        fontFamily: 'Open Sans',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 700,
        marginLeft: '15px',
        lineHeight: 'normal',
    },
    contactLink: {
        textDecoration: 'none', // Optional: Remove underline
    },
    box: {
        borderRadius: '10px',
        background: '#FFF',
        boxShadow: '0px 0px 50px 0px rgba(37, 116, 169, 0.15)',
        maxWidth: '1024px',
        margin: 'auto',
    },

    boxTitle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#FFF',
        textAlign: 'center',
        fontFamily: 'Open Sans',
        fontSize: 18,
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '26px' /* 144.444% */,
        textTransform: 'uppercase',
        borderRadius: '10px 10px 0px 0px',
        borderBottom: '1px solid #ECECEC',
        background: '#2574A9',
        height: '94px',
        padding: '20px',
    },
    emailLink: {
        color: '#2574A9',
        fontFamily: 'Open Sans',
        fontSize: 18,
        fontStyle: 'normal', // You can adjust this to 'italic' if needed
        fontWeight: 700,
        lineHeight: '26px',
        textDecorationLine: 'underline',
    },
    txtBold: {
        color: '#2574A9',
        fontFeatureSettings: "'clig' off, 'liga' off",
        fontFamily: 'Open Sans',
        fontSize: 18,
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '26px',
    },
    mb20: {
        height: '40px',
    },
}));
